import Vue from 'vue';
import VueI18n from 'vue-i18n';
import auth from "./auth";
import globals from "./globals";
import account from "./account";
import dashboard from "./dashboard";
import help from "./help";
import labels from "./labels";

Vue.use(VueI18n);

const messages = {
    'en': Object.assign(
        auth.en,
        globals.en,
        account.en,
        dashboard.en,
        help.en,
        labels.en
    ),
    'de': Object.assign(
        auth.de,
        globals.de,
        account.de,
        dashboard.de,
        help.de,
        labels.de
    ),
    'fr': Object.assign(
        auth.fr,
        globals.fr,
        account.fr,
        dashboard.fr,
        help.fr,
        labels.fr
    ),
    'nl': Object.assign(
        auth.nl,
        globals.nl,
        account.nl,
        dashboard.nl,
        help.nl,
        labels.nl
    ),
    'el': Object.assign(
        auth.el,
        globals.el,
        account.el,
        dashboard.el,
        help.el,
        labels.el
    )
};

const i18n = new VueI18n({
    locale: navigator.language, // set locale
    fallbackLocale: 'de', // set fallback locale
    silentTranslationWarn: true,
    messages, // set locale messages
});

export default i18n;
